import React, { useEffect, useState } from 'react';
/**
 * This will copy the functionality in _fyh/src/components/shared/checkbox.js
 * - since the dependency versions differ between FYH and Viewport Map, we
 *   are unable to reuse the functionality directly, but once the apps
 *   get consolidated, we will be able to have a single Slider component
 */
const Checkbox = ({ checked, value, id, label, onChange, className, style }) => {
    const [inputChecked, setInputChecked] = useState(checked);
    useEffect(() => {
        setInputChecked(checked);
    }, [checked]);
    const handleChange = () => {
        setInputChecked(!inputChecked);
        if (onChange) {
            onChange(!inputChecked);
        }
    };
    return (React.createElement("div", { className: 'checkbox-input-container' + (className ? ' ' + className : ''), style: style },
        React.createElement("input", { type: "checkbox", checked: inputChecked, onChange: handleChange, value: value, id: id, name: id }),
        React.createElement("label", { htmlFor: id }, label)));
};
export default Checkbox;
